function StockOpnameIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.69333 5.66665C7.42667 5.83331 7.17333 6.03331 6.93333 6.26665C6.71333 6.49331 6.51333 6.73998 6.35333 6.99998H4.33333V5.99998C4.33333 5.81331 4.48 5.66665 4.66667 5.66665H7.69333ZM12.3333 4.33331H0.333334V0.333313H12.3333V4.33331ZM11 1.66665H1.66667V2.99998H11V1.66665ZM2.33333 11V4.99998H1V12.3333H6.88C6.50534 11.9482 6.20677 11.4959 6 11H2.33333ZM14.5933 13L13.6667 13.9266L11.5867 11.88C11.1267 12.1666 10.58 12.3333 10 12.3333C8.33333 12.3333 7 11 7 9.33331C7 7.66665 8.33333 6.33331 10 6.33331C11.6667 6.33331 13 7.66665 13 9.33331C13 9.91998 12.8333 10.4733 12.54 10.9333L14.5933 13ZM11.6667 9.33331C11.6667 8.89129 11.4911 8.46736 11.1785 8.1548C10.866 7.84224 10.442 7.66665 10 7.66665C9.55797 7.66665 9.13405 7.84224 8.82149 8.1548C8.50893 8.46736 8.33333 8.89129 8.33333 9.33331C8.33333 9.77534 8.50893 10.1993 8.82149 10.5118C9.13405 10.8244 9.55797 11 10 11C10.442 11 10.866 10.8244 11.1785 10.5118C11.4911 10.1993 11.6667 9.77534 11.6667 9.33331Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default StockOpnameIcon
